// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { color } from "metabase/ui/utils/colors";

interface FormTextAreaRootProps {
  touched?: boolean;
  error?: string | boolean;
}

export const FormTextAreaRoot = styled.textarea<FormTextAreaRootProps>`
  width: 100%;

  &:not(:focus) {
    border-color: ${(props) =>
      props.touched && props.error && color("feedback-negative")};
  }
`;
